import React, { useContext, useEffect, useState } from 'react';

// Formatter Byte
import { niceBytes } from '../../utils/formatter';

// Components
import Header from '../../components/Header/index';
import Title from '../../components/Title/index';

// Images
import RfactorIcon from '../../assets/images/rfactorIcon.png';
import ArmaIcon from '../../assets/images/armaIcon.png';

// Tabelas
import { DataGrid, ColDef, ValueFormatterParams, FilterModel } from '@material-ui/data-grid';

// Ícones material-ui
import { Details, InsertDriveFile, Close } from '@material-ui/icons';
import {
    Tooltip, IconButton, Snackbar, List, ListItem, ListItemText, ListItemIcon, ListItemSecondaryAction,
    Typography, Drawer, Divider, Button
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

// Context
import AuthContext from '../../Context/context';

// Firebase
import { db, firebaseApp } from '../../utils/firebaseConfig';

// React Router
import { useHistory, useParams } from 'react-router-dom';

function ConfigModsAtivos() {
    let params: any = useParams();
    let history = useHistory();
    const { isAdmin } = useContext(AuthContext);

    const [mods, setMods] = useState<any>([]);
    const [mod, setMod] = useState<any>(null);

    // Para funcionar o checkbox
    var listMods: any = [];

    // Drawer
    const [openDrawerRight, setOpenDrawerRight] = useState(false);
    const showDrawerRight = () => setOpenDrawerRight(true);
    const hideDrawerRight = () => setOpenDrawerRight(false);

    // Alert's
    const [alert, setAlert] = useState('');
    const [success, setSuccess] = useState('');

    const [openAlert, setShowAlert] = useState(false);
    const [openSuccess, setShowSuccess] = useState(false);

    const showAlert = () => setShowAlert(true);
    const showSuccess = () => setShowSuccess(true);

    const hideAlert = () => setShowAlert(false);
    const hideSuccess = () => setShowSuccess(false);

    useEffect(() => {
        GetAllMods();
    }, []);

    // Get de todos os mods específicos dos paramêtros
    const GetAllMods = () => {
        let collection = '';

        if (params.jogo === 'rfactor')
            collection = 'RfactorModsLinks'
        else if (params.jogo === 'arma')
            collection = 'ArmaModsLinks'
        else {
            setAlert('Esta coleção de mods não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        db.collection(collection).onSnapshot(resp => {
            let mds = resp.docs.map((m: any) => {
                return {
                    id: m.id,
                    nome: m.data().nome,
                    enviadoPor: m.data().enviadoPor,
                    categoria: m.data().categoria,
                    timeUpdated: m.data().timeUpdated,
                    downloadUrl: m.data().downloadUrl
                }
            });

            setMods(mds);
        })
    }

    const ConfirmarModsAtivos = () => {
        let collection = '';

        if (params.jogo === 'rfactor')
            collection = 'ModsAtivosRfactor'
        else if (params.jogo === 'arma')
            collection = 'ModsAtivosArma'
        else {
            setAlert('Esta coleção de mods não existe. Por favor, corrija o nome da coleção do mod na URL.')
            return showAlert();
        }

        if (listMods.length === 0) {
            setAlert('Selecione ao menos um mod que esteja rodando atualmente no servidor.')
            return showAlert();
        }

        let jogo = `${params.jogo === 'rfactor' ? 'rFactor 2' : 'Arma 2'}`;

        let modsSelecteds: any = [];

        // Coloca na lista todos os mods (completos, não apenas o id) que foram selecionados 
        listMods.forEach((modSelectedId: any) => {
            let found = mods.find((mod: any) => mod.id === modSelectedId);

            if (found !== undefined) {
                modsSelecteds.push(found);
            }
        });

        // Retorna (se houver) a configuração de mods ativos do jogo específico (apenas um será criado, as demais request's serão update)
        db.collection(collection).get()
            .then(resp => {
                // Caso a lista venha vazia, cria uma nova configuraçãooo
                if (resp.docs.length === 0) {
                    db.collection(collection).add({
                        timeUpdated: firebaseApp.firestore.FieldValue.serverTimestamp(),
                        modsAtivos: modsSelecteds
                    })
                        .then(resp => {
                            setSuccess(`Mods ativos do jogo ${jogo} foram atualizados! =)`)
                            return showSuccess();
                        })
                        .catch(err => {
                            console.log('Houve um erro na CRIAÇÃO da configuração dos mods ativos.')
                        })
                }
                else {
                    // Caso a lista venha preenchida, atualiza o primeiro (e único) documento
                    db.collection(collection).doc(resp.docs[0].id).update({
                        timeUpdated: firebaseApp.firestore.FieldValue.serverTimestamp(),
                        modsAtivos: modsSelecteds
                    })
                        .then(resp => {
                            setSuccess(`Mods ativos do jogo ${jogo} foram atualizados! =)`)
                            return showSuccess();
                        })
                        .catch(err => {
                            console.log('Houve um erro na ALTERAÇÃO da configuração dos mods ativos.')
                        })
                }
            })
            .catch(err => {
                console.log('Houve um erro ao resgatar a configuração de mods ativos.')
            })
    }

    // Função para adicionar numa lista todos as linhas selecionadas (comparação de arrays)
    const selectMultiple = (mods: any) => {
        // Se não esta selecionado nenhum mod, reseta a lista
        if (mods.length === 0) {
            return listMods = [];
        }

        // Caso a lista não estiver vazia
        if (listMods.length > 0) {
            for (let i = 0; i < mods.length; i++) {
                // Caso o mod não esteja em listMods, acrescenta-o (IndexOf retorna -1 caso não encontrado)
                if (listMods.indexOf(mods[i]) === -1) {
                    listMods.push(mods[i]);
                }
            }

            // Caso algum listMods não esteja em mods, significa que o usuário removeu a seleção daquela linha
            for (let y = 0; y < listMods.length; y++) {
                if (mods.indexOf(listMods[y]) === -1) {
                    listMods.splice(y, 2)
                }

            }
        }
        else {
            // Caso a lista estiver vazia, apenas acrescenta os mods selecionados
            mods.forEach((mod: any) => {
                listMods.push(mod);
            });
        }
    }

    const filter: FilterModel = {
        items: [{ columnField: 'nome', operatorValue: 'contains' }],
    };

    const columns: ColDef[] = [
        { field: 'nome', headerName: 'Nome do Mod', width: 320 },
        { field: 'enviadoPor', headerName: 'Enviado por', width: 320 },
        {
            field: 'actions',
            headerName: 'Ações',
            width: 170,
            disableClickEventBubbling: true,
            renderCell: (params: ValueFormatterParams) => (
                <div style={{ margin: '0 auto' }}>
                    <Tooltip title="Ver Detalhes" onClick={() => {
                        setMod(params.row);
                        showDrawerRight();
                    }}>
                        <IconButton>
                            <Details />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    return (
        <div>
            <Header />
            {
                params.jogo === 'rfactor' &&
                <Title img={RfactorIcon} title='Selecione os mods ativos no servidor do Rfactor 2' />
            }
            {
                params.jogo === 'arma' &&
                <Title img={ArmaIcon} title='Selecione os mods ativos no servidor do Arma 2' />
            }

            <div style={{ marginTop: '3em' }}>
                <div className="table-container" style={{ height: 500, margin: '0 auto' }}>
                    <DataGrid pagination rows={mods} columns={columns} pageSize={5} rowsPerPageOptions={[5, 10, 25, 50]} checkboxSelection
                        onSelectionChange={(params) => {
                            selectMultiple(params.rowIds);
                        }} showToolbar
                        filterModel={filter}
                    />
                </div>
            </div>

            <p style={{ textAlign: 'center', marginBottom: '2em' }}>
                <small>Os mods selecionados irão aparecer na tela inicial para facilitar a visualização dos players para baixar os mods atuais rodando do servidor</small>
            </p>

            {
                isAdmin &&
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '2em 0' }}>
                        <Button
                            id="btn-padrao"
                            variant="contained"
                            color="default"
                            onClick={() => {
                                ConfirmarModsAtivos();
                            }}
                        >
                            Confirmar Mods Ativos
                        </Button>
                    </div>
                </div>
            }

            <Snackbar open={openSuccess} autoHideDuration={6000} onClose={() => {
                hideSuccess();
                history.push(`/mods-ativos/${params.jogo}`);
            }}>
                <Alert severity="success" variant="filled" onClose={() => {
                    hideSuccess();
                    history.push(`/mods-ativos/${params.jogo}`);
                }}>
                    {success}
                </Alert>
            </Snackbar>

            <Snackbar open={openAlert} autoHideDuration={12000} onClose={hideAlert}>
                <Alert onClose={hideAlert} severity="error" variant="filled">
                    {alert}
                </Alert>
            </Snackbar>

            <Drawer anchor="right" open={openDrawerRight} onClose={() => {
                hideDrawerRight();
                setMod(null);
            }}>
                {
                    mod !== null &&
                    <List style={{ width: '20em' }}>
                        <ListItem style={{ margin: '1.5em 0' }}>
                            <ListItemIcon>
                                <InsertDriveFile />
                            </ListItemIcon>
                            <Typography component="h5" variant="h5">
                                {mod.nome.length > 14 ? mod.nome.substring(0, 14) + '...' : mod.nome}
                            </Typography>
                            <ListItemSecondaryAction style={{ display: 'flex', alignItems: 'center' }} >
                                <IconButton onClick={() => {
                                    hideDrawerRight();
                                    setMod(null);
                                }}>
                                    <Close />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemText
                                primary="Nome"
                                secondary={mod.nome.length > 20 ? mod.nome.substring(0, 20) + '...' : mod.nome}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Categoria do Mod"
                                secondary={mod.categoria}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Criado"
                                secondary={new Date(mod.timeUpdated.toDate()).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Enviado por"
                                secondary={mod.enviadoPor}
                            />
                        </ListItem>
                    </List>
                }
            </Drawer>
        </div>
    );
}

export default ConfigModsAtivos;
